import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

import { CardCoverageStatus } from '#src/__generated__/globalTypes.ts';

export const messages = defineMessages<
  Exclude<CardCoverageStatus, typeof CardCoverageStatus.FULL>
>({
  [CardCoverageStatus.NOT_COVERED]: {
    defaultMessage: 'Ineligible League',
  },
  [CardCoverageStatus.NOT_ELIGIBLE]: {
    defaultMessage: 'Ineligible Player',
  },
  [CardCoverageStatus.LEGEND]: {
    defaultMessage: 'Legend Card',
  },
  [CardCoverageStatus.PARTIAL]: {
    defaultMessage: 'Partial Eligibility',
  },
  [CardCoverageStatus.SPECIAL]: {
    defaultMessage: 'Collectible-only',
  },
});

export const descriptions = defineMessages({
  notCovered: {
    defaultMessage:
      'This player is in a Team not covered by Sorare Pro. His points will not be scored.',
  },
  notCoveredBundle: {
    defaultMessage:
      'Players in this bundle are in teams not covered by Sorare Pro. Their points will not be scored.',
  },
  notEligible: {
    defaultMessage: 'This Card is not eligible for Sorare Pro',
  },
  legend: {
    defaultMessage:
      'This player is not covered in Sorare Pro except for special occasions.',
  },
  partial: {
    defaultMessage:
      'This player is in a club covered only in specific tournaments. His points will not be scored for his domestic league.',
  },
  partialBundle: {
    defaultMessage:
      'Players in this bundle are in teams covered only in specific tournaments. Points will not be scored for domestic leagues.',
  },
  collectible: {
    defaultMessage:
      'This is a special edition collectible-only Card. It cannot be used in Sorare Pro.',
  },
});

export const getCardCoverageDescription = (
  coverageStatus: CardCoverageStatus,
  bundle?: boolean
): MessageDescriptor | null => {
  switch (coverageStatus) {
    case CardCoverageStatus.NOT_ELIGIBLE:
      return descriptions.notEligible;
    case CardCoverageStatus.LEGEND:
      return descriptions.legend;
    case CardCoverageStatus.PARTIAL:
      return bundle ? descriptions.partialBundle : descriptions.partial;
    case CardCoverageStatus.SPECIAL:
      return descriptions.collectible;
    case CardCoverageStatus.NOT_COVERED:
      return bundle ? descriptions.notCoveredBundle : descriptions.notCovered;
    default:
      return null;
  }
};
